import axios from 'src/utils/axios';
import { API_BASE_URL } from 'src/config';

export const GET_PAYMENT_METHODS = '@paymentMethod/get-payment-methods';
export const REQUEST_PAYMENT_METHODS = '@paymentMethod/request-payment-methods';

export function getPaymentMethods() {
  const request = axios.get(`${API_BASE_URL}/payment-method`);

  return (dispatch) => {
    dispatch({ type: REQUEST_PAYMENT_METHODS });

    request
      .then((response) =>
        dispatch({
          type: GET_PAYMENT_METHODS,
          payload: { paymentMethods: response.data }
        })
      )
      .catch((error) => {
        let message = '';
        if (error.response) {
          message = error.response.data;
        }
        dispatch({
          type: GET_PAYMENT_METHODS,
          payload: { paymentMethods: [], message }
        });
      });
  };
}
